// 商店商品（月卡、金幣包）與「請人幫忙付」的分享文案
// 對應 docs/PRD-Freemium.md 第 5、6 節；價格與數量只改這裡

export const ShopItemId = {
  MonthlyCard: 'monthly-card',
  PackSmall: 'pack-90',
  PackMedium: 'pack-300',
  PackLarge: 'pack-990',
} as const;
export type TShopItemId = (typeof ShopItemId)[keyof typeof ShopItemId];

export interface IShopItem {
  readonly id: TShopItemId;
  readonly name: string;
  readonly priceTwd: number;
  readonly coins: number; // 金幣包的金幣數；月卡為 0（權益另列）
  readonly highlights: readonly string[];
  readonly image: string; // public/ 底下的路徑
}

export const SHOP_ITEMS: readonly IShopItem[] = [
  {
    id: ShopItemId.MonthlyCard,
    name: '好運月卡',
    priceTwd: 149,
    coins: 0,
    highlights: ['不限將數、沒有廣告', '每天簽到 5,000 金幣', '連續 7 天領 10,000'],
    image: 'assets/ui/shop-card.png',
  },
  {
    id: ShopItemId.PackSmall,
    name: '小包金幣',
    priceTwd: 90,
    coins: 30_000,
    highlights: ['先試試看'],
    image: 'assets/ui/shop-pack-s.png',
  },
  {
    id: ShopItemId.PackMedium,
    name: '福袋金幣',
    priceTwd: 300,
    coins: 120_000,
    highlights: ['多送 33%'],
    image: 'assets/ui/shop-pack-m.png',
  },
  {
    id: ShopItemId.PackLarge,
    name: '寶箱金幣',
    priceTwd: 990,
    coins: 450_000,
    highlights: ['多送 50%'],
    image: 'assets/ui/shop-pack-l.png',
  },
];

export const findShopItem = (id: unknown): IShopItem | undefined =>
  SHOP_ITEMS.find((item) => item.id === id);

export const HELP_REQUEST_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 代買連結有效期
export const HELP_SHARE_TEXT = '我今天手氣不太好，幫我加點金幣啦～'; // 撒嬌語氣，不寫成帳單

/** 親友打開的代買頁；openExternalBrowser=1 讓 LINE 用外部瀏覽器開。 */
export const helpPageUrl = (origin: string, token: string): string =>
  `${origin}/gift.html?t=${token}&openExternalBrowser=1`;

/** LINE 分享網址：玩家自己在 LINE 選要傳給誰。 */
export const lineShareUrl = (text: string): string =>
  `https://line.me/R/share?text=${encodeURIComponent(text)}`;
